import {
  createSlice, createAsyncThunk,
} from '@reduxjs/toolkit';
import axios from 'axios';
import { CLOUDFLARE_TRACE_URL } from 'appenv';

const countryCodeExpression = /loc=([\w]{2})/;

export const getLocation = createAsyncThunk(
  'location/getLocation',
  async (_, { getState }) => {
    try {
      const { data } = await axios.get(CLOUDFLARE_TRACE_URL);
      const countryCode = countryCodeExpression.exec(data);
      return countryCode[1];
    } catch (error) {
      console.error(error);
    }
    const { locale } = (getState() as any).localization;
    return locale === 'zh-Hans' ? 'CN' : 'HK';
  },
);

export const location = createSlice({
  name: 'location',
  initialState: 'HK',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLocation.fulfilled, (state: any, action) => action.payload);
  },
});

export default location.reducer;
